import Cookies from 'js-cookie';
import {
    PICLIST,
    LOGINSUC,
    LOGINERR,
    FILEUPLOAD,
    VIDEOSUB
} from './action-types';

// api接口
import {
    reqPicList,
    reqFileupload,
    reqVideosub
} from '../api/https'

// 获取用户cookie信息
import {
    getDocumentCookie
} from '../util/utils';

const fileupload = (msg) => ({ type: FILEUPLOAD, data: msg });
const videosub = (msg) => ({ type: VIDEOSUB, data: msg });
const piclist = (msg) => ({ type: PICLIST, data: msg });
const loginsuc = (msg) => ({ type: LOGINSUC, data: msg }); //登录成功
const loginerr = (msg) => ({ type: LOGINERR, data: msg }); //登录失败
// 音频上传接口
export const fileUpload = (params) => {
        console.log(params)
        return async dispatch => {
            const response = await reqFileupload(params);
            const result = response.data;
            if (result.ret_no === 200) {
                dispatch(fileupload(result.ret_msg));
            }
        }
    }
    // 音频保存接口
export const videoSub = (params) => {
    return async dispatch => {
        const response = await reqVideosub(params);
        const result = response.data;
        if (result.ret_no === 200) {
            dispatch(videosub(result.ret_msg));
        }
    }
}

// 获取用户信息
export const getUserInfo = () => {
        return async dispatch => {
            const cookiepre = getDocumentCookie();
            if (cookiepre !== '') {
                var login_userinfo = Cookies.getJSON(cookiepre);
                if (login_userinfo && typeof(login_userinfo) === 'object' &&
                    login_userinfo['uid'] && login_userinfo['username']) {
                    let preurl = '//bbs.360.cn/home.php?mod=space&uid=';
                    let userinfo = {
                        username: login_userinfo['username'],
                        urls: preurl + login_userinfo['uid'],
                        islogin: true
                    }
                    dispatch(loginsuc(userinfo))
                }
            } else {
                dispatch(loginerr())
            }
        }
    }
    // 获取图片列表
export const getPicList = (params) => {
    return async dispatch => {
        const response = await reqPicList(params);
        const result = response.data;
        if (result.ret_no === 200) {
            dispatch(piclist(result.ret_msg));
        }
    }
}


// WEBPACK FOOTER //
// ./src/redux/actions.js